<template>
  <div>
    <v-container fluid class="pa-0 ma-0">
      <div class="first-content">
        <div class="content-wrapper">
          <v-row no-gutters align="center" class="first-content-row-height">
            <div class="main-text-first">
              <h1>
                부동산 투자의 등대
                <br />
                <span>리치고 Expert</span>
                <div>부동산 지표 / 경제 지표들의 데이터 시각화를 통해<br/>현명한 부동산의 의사결정을 돕습니다.</div>
              </h1>
              <div class="main-button-wrapper">
                <router-link tag="button" to="/service">서비스 소개 바로가기</router-link>
              </div>
            </div>
          </v-row>
        </div>
      </div>
      <div class="background-color-white">
        <div class="content-wrapper">
          <v-row no-gutters align="center" class="row-height">
            <div class="main-text">
              <h1>
                부동산은 어렵지만
                <br />리치고는 쉽습니다
              </h1>
              <p></p>
              <div>
                <h3>
                  단순한 숫자 나열을 넘어 복잡하고 다양한 부동산
                  <br />관련 데이터들을 한 눈에 쉽게 비교해 볼 수 있도록
                  <br />시각화된 그래프를 서비스를 제공합니다.
                </h3>
              </div>
              <div>
                <v-btn
                  color="primary"
                  x-large
                  class="font-weight-bold mt-4"
                  rounded
                  height="30"
                  to="/service"
                >더 알아보기</v-btn>
              </div>
            </div>
            <div class="main-third-img"></div>
          </v-row>
        </div>
      </div>
      <div class="background-color-gray">
        <div class="content-wrapper">
          <v-row no-gutters align="center" class="row-height">
            <div class="main-text">
              <h1>
                '썰'은 불확실 하지만
                <br />리치고는 정확합니다
              </h1>
              <p></p>
              <div>
                <h3>
                  리치고는 부동산 투자에 빅데이터를 접목시켜 한 두가지
                  <br />지표가 아닌 부동산 시장에 영향을 줄 수 있는 모든 요소를
                  <br />종합 분석하는 가장 과학적인 투자 솔루션을 제안합니다.
                </h3>
              </div>
              <div>
                <v-btn
                  color="primary"
                  x-large
                  class="font-weight-bold mt-4"
                  rounded
                  height="30"
                  to="/service"
                >더 알아보기</v-btn>
              </div>
            </div>
            <div class="main-fourth-img"></div>
          </v-row>
        </div>
      </div>

      <div class="background-color-white">
        <div class="content-wrapper">
          <v-row no-gutters align="center" class="row-height">
            <div class="main-text">
              <h1>
                검색창은 느리지만
                <br />리치고는 빠릅니다
              </h1>
              <p></p>
              <div>
                <h3>
                  다양한 데이터를 객관적으로 분석한 100여개의
                  <br />차트를 통해 이기는 투자를 위한 최신의 부동산
                  <br />데이터를 보다 빠르게 만나실 수 있습니다.
                </h3>
              </div>
              <div>
                <v-btn
                  color="primary"
                  x-large
                  class="font-weight-bold mt-4"
                  rounded
                  height="30"
                  to="/service"
                >더 알아보기</v-btn>
              </div>
            </div>
            <div class="main-fifth-img"></div>
          </v-row>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
// import SaleComponent from "../components/payment/SaleComponent";

export default {
  data() {
    return {
      dialog: true
    };
  }
};
</script>

<style scoped>
.first-content {
  width: 100%;
  height: 800px;
  background-position: 0%;
  background-image: url("../assets/main/web_banner.png");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.first-content h1 {
  margin-top: 20px;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.3125;
  padding: 0 20px;
  color: #FFFFFF;
  text-align: center;
}



.content-wrapper {
  max-width: 1050px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  text-align: left;
}

.first-content-row-height {
  height: 874px;
}

.main-button-wrapper {
  margin-left: 25px;
  text-align: center;
}

.main-button-wrapper > button {
  margin-top: 29px;
  height: 56px;
  border: 1px solid #FFFFFF;
  color: #FFFFFF;
  font-size: 18px;
  padding: 16px 36px;
  border-radius: 4px;
}

.row-height {
  min-height: 550px;
}

.background-color-gray {
  background-color: #fafafa;
}

.background-color-white {
  background-color: #ffffff;
}

.main-text-first {
  text-align: left;
  position: relative;
  top: -80px;
  left: 0px;
}

.main-text-first div {
  margin-top: 18px;
  font-size: 17px;
}
.main-text {
  text-align: left;
}

h1 {
  margin: 0;
  padding: 0;
  font-size: 48px;
  font-weight: 400;
  color: #202020;
}

h3 {
  margin: 0;
  padding: 0;
  font-weight: 400;
  color: #454f5d;
}

.main-third-img {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 500px;
  height: 370px;
  background-image: url("../assets/main/02.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.main-fourth-img {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-55%);
  width: 500px;
  height: 288px;
  background-image: url("../assets/main/03.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.main-fifth-img {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-58%);
  width: 500px;
  height: 311px;
  background-image: url("../assets/main/04.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.product {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.product-card {
  display: inline-block;
  margin: 0 5px;
  width: 285px;
  background: #fff;
  box-shadow: 4px 6px 9px 0 rgba(58, 62, 49, 0.05),
    8px 22px 60px 0 rgba(57, 58, 48, 0.07);
  border-radius: 4px;
}

.product-title {
  margin: 30px 30px 15px 30px;
  font-size: 24px;
  font-weight: 400;
  color: #454f5d;
}

.product-subtitle {
  margin: 0px 30px 0px 30px;
  font-size: 16px;
  font-weight: 400;
  color: #454f5d;
}

.product-sale {
  font-size: 36px;
  font-weight: 400;
  color: #F5A21E;
  text-shadow: 2px 2px 2px gray;
}

.product-comment {
  font-size: 10px;
  color: gray;
}

.product-text {
  margin: 15px 30px -15px 30px;
  font-size: 12px;
  font-weight: 400;
  color: #454f5d;
}

p {
  margin: 0px;
}

.product-button {
  margin: 35px auto;
  width: 230px;
  height: z25px;
}

@media only screen and (max-width: 1000px) {
  .first-content-row-height,
  .first-content {
    height: 500px;
  }

  .main-button-wrapper {
    margin-left: 0;
  }

  .first-content {
    background-position: 55%;
  }

  .first-content h1 {
    font-size: 27px;
  }

  .main-text-first {
    width: 100%;
    text-align: center;
    top: 0;
  }

  .main-text {
    width: 100%;
    text-align: center;
  }

  h1 {
    font-size: 28px;
    padding: 0 10px;
  }

  h3 {
    font-size: 11px;
    padding: 0 10px;
  }

  .main-third-img,
  .main-fourth-img,
  .main-fifth-img {
    position: inherit;
    transform: translateY(0);
    margin: 0 auto;
    text-align: center;
    background-size: contain;
  }

  .main-third-img {
    width: 300px;
    height: 250px;
  }

  .main-fourth-img {
    width: 300px;
    height: 200px;
  }

  .main-fifth-img {
    width: 300px;
    height: 190px;
  }

  .product {
    position: inherit;
    transform: translateY(0);
    margin: 30px auto;
  }
  .product-card {
    margin: 10px 0;
  }
}

@media only screen and (max-width: 720px) {
  .first-content {
    background-image: url("../assets/main/mobile_banner.png");
    height: 600px;

    background-size: cover;
  }
}
</style>
